import * as React from 'react';
import * as classNames from 'classnames';
import FacebookLogin from 'react-facebook-login';
import {BubbleError} from '../bubble-error/bubble-error';
import {FB_APP_ID} from '../../utils/config';

export type FacebookSuccessCallback = (response: IFacebookResponse) => void;
export type FacebookFailureCallback = (response: IFacebookErrorResponse) => void;
export interface IFacebookResponse extends FacebookLogin.IReactFacebookLoginInfo {}
export interface IFacebookErrorResponse extends FacebookLogin.IReactFacebookLoginError {}

export interface IFacebookAuthProps {
  bottomBlank?: boolean;
  buttonText?: string;
  className?: string;
  children?: any;
  topBlank?: boolean;
  disabled?: boolean;
  error?: string;

  onSuccess: FacebookSuccessCallback;
  onFailure: FacebookFailureCallback;
}

const mapCallback = (onSuccess: FacebookSuccessCallback, onFailure: FacebookFailureCallback) => {
  return (response: IFacebookResponse | IFacebookErrorResponse) => (
    'status' in response
      ? onFailure(response as IFacebookErrorResponse)
      : onSuccess(response as IFacebookResponse)
  );
};

import './styles.sass';

const CLASS_NAME: string = 'facebook-auth-component';

export const FacebookAuth: React.StatelessComponent<IFacebookAuthProps> = ({
  bottomBlank,
  buttonText,
  className,
  topBlank,
  disabled,
  children,
  error,
  onSuccess,
  onFailure,
}: IFacebookAuthProps) => {
  const classes = classNames(CLASS_NAME, {
    [`${CLASS_NAME}_bottom-blank`]: bottomBlank,
    [`${CLASS_NAME}_top-blank`]: topBlank,
  });

  return (
    <div className={classes}>
      <FacebookLogin
        isDisabled={disabled}
        textButton={buttonText || ''}
        cssClass={className}
        language={'en_US'}
        fields={'email,first_name,last_name'}
        appId={FB_APP_ID}
        scope={'public_profile,email'}
        xfbml={true}
        icon={children}
        callback={mapCallback(onSuccess, onFailure)}
      />

      <BubbleError error={error} />
    </div>
  );
};
